module.exports = __webpack_public_path__ + "img/Grundausbildungsgruppe.101e7c2c.svg";